import { render, staticRenderFns } from "./genre-hero.vue?vue&type=template&id=5416c62b&scoped=true"
import script from "./genre-hero.vue?vue&type=script&lang=js"
export * from "./genre-hero.vue?vue&type=script&lang=js"
import style0 from "./genre-hero.vue?vue&type=style&index=0&id=5416c62b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5416c62b",
  null
  
)

export default component.exports